export default __webpack_public_path__ + "static/media/burger.7f0605c2.svg";